import { HANDLE_COURSE_DETAILS, RESET_COURSE_DETAILS, SET_COURSE_SCROLL } from '../actions/types';

const initialState = {
    courseList: [],
    scrollPositionY: 0,
    selectedCourseIndex: -1,
    searchText: "",
    skip: 0,
    limit: 20,
    continueScroll: false
};
//eslint-disable-next-line
export default function (state = initialState, action) {
    switch (action.type) {
        case HANDLE_COURSE_DETAILS:
            return {
                ...state,
                ...action.payload
            };
        case RESET_COURSE_DETAILS:
            return initialState;

        case SET_COURSE_SCROLL:
            return {
                ...state,
                ...action.payload
            };
        default:
            return state;
    }
}